import { useOrderViewStore } from '@/store/pinia/orderview.store';
import { isStandardWorkflow, isSwedishWorkflow } from '@/services/config.service';
import { computed } from 'vue';
import { UNTOUCHED } from '@/store/const';
import { STEPS } from '@/services/const.enum';
import  Vue from 'vue';
import type {Store} from 'vuex';

function registerBillingProfile(orderViewStore: any, store: Store<any>) {
  Vue.component('BillingProfile', () => import('./components/BillingProfile.vue'));
  orderViewStore.addCard({
    name: STEPS.BILLING_PROFILE,
    step: () => isSwedishWorkflow && !store.getters['loggedIn'] ?
      STEPS.DOMAIN_PROFILE : STEPS.BILLING_PROFILE,
    isShown: computed(() => !store.getters['loggedIn']
      || isStandardWorkflow
      || store.getters['progressByUser'][STEPS.BILLING_PROFILE] !== UNTOUCHED),
    isReadOnly: computed(() => false),
  });
}

function registerDomainProfile(orderViewStore: any, store: Store<any>) {
  Vue.component('DomainProfile', () => import('./components/DomainProfile.vue'));
  orderViewStore.addCard({
    name: STEPS.DOMAIN_PROFILE,
    step: () => STEPS.DOMAIN_PROFILE,
    isShown: computed(() => {
      return store.getters['loggedIn']
          && (isSwedishWorkflow || (store.getters['progressByUser'][STEPS.DOMAIN_PROFILE] !== UNTOUCHED
            && (store.state.cart.domainProfileRequired || store.getters['allDomainProfilesDefined'])));
    }
    ),
    isReadOnly: computed(() => store.getters['allDomainProfilesDefined']),
  });
}

export const setupProfiles = (store: Store<any>) => {
  const orderViewStore = useOrderViewStore();

  if (isSwedishWorkflow) {
    registerDomainProfile(orderViewStore, store);
    registerBillingProfile(orderViewStore, store);
  } else {
    registerBillingProfile(orderViewStore, store);
    registerDomainProfile(orderViewStore, store);
  }
};
